module.exports = __webpack_public_path__ + "img/farzana-christopher-155.e2045ec8.jpg";